import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CONSENT_EVENT, getConsent, grantConsent, denyConsent } from "@/lib/analytics";

export const OPEN_CONSENT_EVENT = "cl-open-consent";

export const ConsentBanner = () => {
  const [open, setOpen] = useState(() => getConsent() === null);

  useEffect(() => {
    const show = () => setOpen(true);
    const sync = () => setOpen(getConsent() === null);
    window.addEventListener(OPEN_CONSENT_EVENT, show);
    window.addEventListener(CONSENT_EVENT, sync);
    return () => {
      window.removeEventListener(OPEN_CONSENT_EVENT, show);
      window.removeEventListener(CONSENT_EVENT, sync);
    };
  }, []);

  if (!open) return null;
  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Analytics choices"
      data-testid="consent-banner"
      className="fixed inset-x-3 bottom-3 z-[60] mx-auto max-w-xl rounded-2xl border border-[#D9A441]/30 bg-[#131422]/95 p-5 shadow-[0_0_40px_rgba(0,0,0,0.5)] backdrop-blur-xl sm:bottom-5"
    >
      <p className="text-sm leading-relaxed text-[#F8F3E6]">
        May we use analytics cookies to learn which pages help people find a reading? Analytics never
        receives your questions, readings or journal.{" "}
        <Link to="/privacy" className="text-[#E5C365] underline underline-offset-4" data-testid="consent-privacy-link">
          Privacy Policy
        </Link>
      </p>
      <div className="mt-4 flex flex-wrap gap-3">
        <button
          onClick={() => { grantConsent(); setOpen(false); }}
          data-testid="consent-accept-btn"
          className="rounded-full bg-[#D9A441] px-5 py-2 text-sm font-medium text-[#0B0C15] transition-colors hover:bg-[#E5C365]"
        >
          Allow analytics
        </button>
        <button
          onClick={() => { denyConsent(); setOpen(false); }}
          data-testid="consent-decline-btn"
          className="rounded-full border border-[#D9A441]/50 px-5 py-2 text-sm font-medium text-[#E5C365] transition-colors hover:bg-[#D9A441]/10"
        >
          No thanks
        </button>
      </div>
    </div>
  );
};
